module.exports = __webpack_public_path__ + "static/img/部件组成5-SACU200.8237dd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-2/部件组成5-SACU200.png
// module id = IZMR
// module chunks = 0